import { render } from "./GanttChartOriginal.vue?vue&type=template&id=18d5b6d7"
import script from "./GanttChartOriginal.vue?vue&type=script&lang=js"
export * from "./GanttChartOriginal.vue?vue&type=script&lang=js"

import "./GanttChartOriginal.vue?vue&type=style&index=0&id=18d5b6d7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__